module.exports = __webpack_public_path__ + "img/ic_twotone_cal.2ee8f192.png";